import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/flags.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initGA, trackPageView } from './utils/analytics';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initGA(process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-EXJTX9677M');
trackPageView();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
